import api from './api';

const userService = {
  // Obtenir tous les utilisateurs
  getUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },
  
  // Obtenir un utilisateur par ID
  getUser: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },
  
// Obtenir le nom d'utilisateur par ID
getUsernameById: async (id) => {
  try {
    const response = await api.get(`/users/${id}/username`);
    return {
      success: true,
      data: response.data.data
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || 'Erreur lors de la récupération du nom d\'utilisateur'
    };
  }
},




  // Créer un utilisateur (via le endpoint register)
  createUser: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },
  
  // Mettre à jour un utilisateur
  updateUser: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },
  
  // Supprimer un utilisateur
  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },
  
  // Mettre à jour les permissions d'un utilisateur
  updatePermissions: async (id, permissions) => {
    const response = await api.put(`/users/${id}/permissions`, { permissions });
    return response.data;
  },
  
  // Mettre à jour le mot de passe
  updatePassword: async (id, passwordData) => {
    const response = await api.put(`/users/${id}/password`, passwordData);
    return response.data;
  }
};

export default userService;